export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-zoom-out-ba7e919d9ac07c86d81a001625379639.svg";